import classNames from "classnames";
import React from "react";

interface PurpleHeaderCardProps {
  wide?: boolean
}

export const PurpleHeaderCard = (props: React.PropsWithChildren<PurpleHeaderCardProps>) =>
  <div className={classNames("purple-header", { "purple-header-wide": props.wide })}>
    {props.children}
  </div>;

export const PurpleHeaderDivider = () => <div className="purple-header-divider" />;

export const PurpleHeaderVerticalDivider = () => <div className="purple-header-vertical-divider" />;
